<div class="auth-page">
  <div class="ambient-glow"></div>

  <!-- Animated trading background -->
  <div class="trading-bg" aria-hidden="true">
    <div class="candles-row">
      <div class="candle-bar" style="height:15%;animation-delay:0.3s"></div>
      <div class="candle-bar" style="height:30%;animation-delay:0.7s"></div>
      <div class="candle-bar" style="height:20%;animation-delay:1.0s"></div>
      <div class="candle-bar" style="height:40%;animation-delay:1.3s"></div>
      <div class="candle-bar" style="height:35%;animation-delay:1.6s"></div>
      <div class="candle-bar" style="height:55%;animation-delay:1.9s"></div>
      <div class="candle-bar" style="height:50%;animation-delay:2.2s"></div>
      <div class="candle-bar" style="height:70%;animation-delay:2.5s"></div>
      <div class="candle-bar" style="height:65%;animation-delay:2.8s"></div>
      <div class="candle-bar" style="height:85%;animation-delay:3.1s"></div>
    </div>
    <svg class="chart-svg" preserveAspectRatio="none" viewBox="0 0 1000 1000">
      <defs>
        <filter id="reset-glow">
          <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
          <feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>
      <path class="chart-line"
        d="M0,900 L150,820 L300,860 L450,680 L600,720 L750,500 L900,280 L1000,200"
        fill="none" stroke-width="3" filter="url(#reset-glow)"/>
    </svg>
  </div>

  <div class="theme-toggle-btn" (click)="themeService.toggleTheme()" [title]="themeService.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
    <span class="material-symbols-outlined">{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</span>
  </div>

  <div class="auth-container">
    <div class="auth-logo">
      <span class="material-symbols-outlined logo-icon">stacked_line_chart</span>
      <span class="logo-text">Nectum</span>
    </div>

    <div class="auth-card">
      <!-- Token inválido / expirado -->
      <ng-container *ngIf="tokenError">
        <div class="status-block">
          <span class="material-symbols-outlined status-icon error-icon">error</span>
          <h2 class="card-title">Enlace inválido</h2>
          <p class="card-subtitle">El enlace de recuperación es inválido o ha expirado.</p>
          <p class="status-hint">Solicita un nuevo enlace desde la pantalla de inicio de sesión.</p>
          <a routerLink="/login" class="submit-btn">Volver al inicio de sesión</a>
        </div>
      </ng-container>

      <!-- Éxito -->
      <ng-container *ngIf="successUpdated">
        <div class="status-block">
          <span class="material-symbols-outlined status-icon success-icon">check_circle</span>
          <h2 class="card-title">¡Contraseña actualizada!</h2>
          <p class="card-subtitle">Ya puedes iniciar sesión con tu nueva contraseña.</p>
          <a routerLink="/login" class="submit-btn">Ir al inicio de sesión</a>
        </div>
      </ng-container>

      <!-- Formulario -->
      <ng-container *ngIf="!tokenError && !successUpdated">
        <div class="card-header">
          <h2>Nueva contraseña</h2>
          <p>Introduce y confirma tu nueva contraseña.</p>
        </div>

        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
          <div class="form-field">
            <label for="nuevaClave" class="field-label">Nueva contraseña</label>
            <div class="input-wrapper">
              <span class="material-symbols-outlined field-icon">lock</span>
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="nuevaClave"
                formControlName="nuevaClave"
                placeholder="Mínimo 6 caracteres"
                class="field-input has-toggle"
                [class.field-error]="resetForm.get('nuevaClave')?.invalid && resetForm.get('nuevaClave')?.touched"
              />
              <button type="button" class="toggle-btn" (click)="showPassword = !showPassword">
                <span class="material-symbols-outlined">{{ showPassword ? 'visibility' : 'visibility_off' }}</span>
              </button>
            </div>
            <span class="error-msg"
              *ngIf="resetForm.get('nuevaClave')?.invalid && resetForm.get('nuevaClave')?.touched">
              Mínimo 6 caracteres.
            </span>
          </div>

          <div class="form-field">
            <label for="confirmarClave" class="field-label">Confirmar contraseña</label>
            <div class="input-wrapper">
              <span class="material-symbols-outlined field-icon">lock_reset</span>
              <input
                [type]="showConfirm ? 'text' : 'password'"
                id="confirmarClave"
                formControlName="confirmarClave"
                placeholder="Repite la contraseña"
                class="field-input has-toggle"
                [class.field-error]="resetForm.errors?.['mismatch'] && resetForm.get('confirmarClave')?.touched"
              />
              <button type="button" class="toggle-btn" (click)="showConfirm = !showConfirm">
                <span class="material-symbols-outlined">{{ showConfirm ? 'visibility' : 'visibility_off' }}</span>
              </button>
            </div>
            <span class="error-msg"
              *ngIf="resetForm.errors?.['mismatch'] && resetForm.get('confirmarClave')?.touched">
              Las contraseñas no coinciden.
            </span>
          </div>

          <button type="submit" class="submit-btn" [disabled]="isLoading || resetForm.invalid">
            <span *ngIf="!isLoading">Guardar nueva contraseña</span>
            <mat-spinner *ngIf="isLoading" diameter="20" color="accent"></mat-spinner>
          </button>
        </form>
      </ng-container>
    </div>
  </div>
</div>
